import React, { useState } from "react";

import * as S from "./styles";
import { MessageRight, MessageLeft } from "components/shared";
import { Cam } from "components/shared";
interface Props {
  active: boolean;
}
export const Slide10: React.FC<Props> = ({ active }) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <S.Container>
      <S.Chat>
        {active && (
          <S.ChatContent>
            <S.HeaderChat>
              <S.IconLeft />
              <S.Avatar />
              <S.Name>Mickael Meu Amor</S.Name>
            </S.HeaderChat>
            <MessageLeft
              message={`🙏🏿 ❤️`}
              time="18:22"
              className="animate__animated animate__backInLeft animate__faster"
            />
            <MessageRight
              message={`Vamos sim. Já, já, tudo irá acabar<br />e estaremos juntos novamente`}
              time="18:23"
              className="animate__animated animate__backInRight animate__faster animate__delay-1s"
            />
            <MessageRight
              message={`Quero que você saiba que<br /> te amo muito`}
              time="18:23"
              className="animate__animated animate__backInRight animate__faster animate__delay-2s"
            />
            <MessageLeft
              message={`Te amo *meu amor (sotaque<br />francês 😅 😂 ❤️)`}
              time="18:24"
              className="animate__animated animate__backInLeft animate__faster animate__delay-4s"
            />
            <MessageRight
              message={`hahahaha`}
              time="18:24"
              className="animate__animated animate__backInRight animate__faster animate__delay-5s"
            />
            <S.ButtonPhoto onClick={() => setOpen(true)}>
              <S.IconPlay />
              Foto
            </S.ButtonPhoto>
          </S.ChatContent>
        )}
      </S.Chat>
      <S.Overlay active={open}>
        <S.Modal active={open}>
          <S.PhotoWrapper>
            <S.ButtonClose onClick={() => setOpen(false)}>
              <S.IconClose />
            </S.ButtonClose>
            <Cam />
            <S.PhotoModal />
          </S.PhotoWrapper>
          <S.Credit>
            Vestido, Teodora Oshima, R$ 1.460. Brinco, R$ 1.490, e anel, R$
            1.600, ambos Brennheisen.
          </S.Credit>
        </S.Modal>
      </S.Overlay>
      <S.Photo>
        <S.Text>
          Vestido, Teodora Oshima, R$ 1.460. Brinco, R$ 1.490, e anel, R$ 1.600,
          ambos Brennheisen.
        </S.Text>
      </S.Photo>
    </S.Container>
  );
};
